import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {Link, useHistory, useParams} from "react-router-dom";

import {CircularProgress, Tooltip} from "@mui/material";
import {Ballot} from "@mui/icons-material";

import createMapper from "api/feed/mapper/create";
import {primaryColor} from "assets/jss/main";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

MapperButton.propTypes = {
    feed: PropTypes.shape({
        id: PropTypes.string.isRequired,
        '@id': PropTypes.string.isRequired,
        mapper: PropTypes.string,
    }).isRequired,
};

function MapperButton({feed}) {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const {id: retailerId} = useParams();

    if (feed["mapper"]) {
        return (
            <Link
                to={MarketplaceRoutes.RETAILER_FEED_MAPPER_EDIT(
                    retailerId,
                    encodeURIComponent(feed['@id']),
                    encodeURIComponent(feed.mapper)
                )}
            >
                <Tooltip
                    title={<FormattedMessage
                        id={"feed.list.table.tooltip.map"}/>}>
                    <Ballot style={{color: primaryColor, cursor: "pointer"}}/>
                </Tooltip>
            </Link>
        );
    }

    function handleCreate(e) {
        e.stopPropagation();
        setLoading(true);

        createMapper(feed)
            .then((created) => {
                history.push(
                    MarketplaceRoutes.RETAILER_FEED_MAPPER_EDIT(retailerId, encodeURIComponent(feed['@id']), encodeURIComponent(created['@id']))
                );
            })
            .catch(() => setLoading(false));
    }

    return (
        <div onClick={handleCreate}>
            <Tooltip title={<FormattedMessage id={"feed.list.table.tooltip.map"}/>}>
                {loading ?
                    <CircularProgress size={20}/> :
                    <Ballot style={{color: primaryColor, cursor: "pointer"}}/>}
            </Tooltip>
        </div>
    );
}

export default MapperButton;
